<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-3/3">
        <vs-card>
          <h6 class="font-bold">Touchpoint Overall Result</h6>
          <div class="left-card-container">
            <div class="flex-item-left">
              <p class="label text-black mt-2">Evaluation à afficher</p>
              <v-select class="w-full" label="name" placeholder="Selectionner" :reduce="(evaluation) => evaluation.id"
                :options="evaluations" v-model="evaluation_id">
                <template slot="spinner" v-if="evaluations.length == 0">
                  <div>
                    <svg class="spinner" viewBox="0 0 50 50">
                      <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                  </div>
                </template>
              </v-select>
            </div>
            <div class="flex-item-right pt-8 ml-2">
              <vs-button @click="getTouchPointStats()" size="small" :color="$store.state.aa_button_color"
                class="font-bold ml-1 export-button text-dark">Appliquer</vs-button>
            </div>
          </div>
        </vs-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-3/3">
        <vs-card class="stats-perf">
          <h6>Touchpoint Overall Result :</h6>
          <span class="mt-4 font-bold">3 dernieres évaluations</span>
          <div class="">
            <apexchart v-if="!loading" type="bar" height="430" :options="chartOptions" :series="series"></apexchart>
          </div>
        </vs-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-3/3">
        <vs-card class="stats-perf">
          <!-- <h6>Données du graphes</h6> -->
          <div class="left-card-container">
            <div class="flex-item-left pt-4">
              <h6 class="label text-black mt-2">Données du graphes</h6>
            </div>
            <div class="flex-item-right pt-4 ml-2">
              <vs-button @click="exportPerfs()" class="activate-button text-dark font-bold" color="black"
                size="small">Exporter les
                statistiques</vs-button>
            </div>
          </div>
          <div class="vx-row mt-8">
            <vs-table ref="table" :data="service_stats_datas" class="w-full">
              <template slot="thead" class="bg-table-stats">
                <vs-th v-for="(item, index) in service_stats_headers" :key="index">{{ item }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td v-for="(item, index) in tr" :key="index"> {{ item }} </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import { _buildQuery } from "../../../../helpers/buildquery";
export default {
  name: "TouchPointOverAllResults",
  data() {
    return {
      evaluation_id: "",
      evaluations: [],
      series: [
        {
          name: "TTC 1",
          data: [44, 55, 41],
        },
        {
          name: "TTC 2",
          data: [53, 32, 33],
        },
        {
          name: "TTC 3",
          data: [20, 100, 10],
        },
      ],
      chartOptions: {
        legend: {
          position: "top",
          horizontalAlign: "right",
          showForSingleSeries: true,
        },
        colors: ["#FFCB05", "#1261A4", "#202020"],
        chart: {
          type: "bar",
          height: 430,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: "top",
            },
            borderRadius: 6,
            borderRadiusApplication: "end",
            columnWidth: "5%",
            // endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
          offsetX: 0,
          offsetY: -20,
          style: {
            fontSize: "10px",
            colors: ["#000"],
          },
        },
        stroke: {
          colors: ["transparent"],
          width: 3
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: ["RAC", " Franchise", "Agences"],
        },

      },
      service_stats_headers: [],
      service_stats_datas: [],
      loading: false
    };
  },
  methods: {
    async getEvaluations() {
      try {
        let response = await this.$http.get("/evaluations?limit=3");
        if (response) {
          this.evaluations = response.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getTouchPointStats() {
      try {
        this.series = [];
        this.loading = true;
        this.$vs.loading();
        let params = {
          evaluation: this.evaluation_id ? this.evaluation_id : '',
        };
        let response = await this.$http.get('/stats/rapport-tcc/touchpoint-result' + _buildQuery(params));
        if (response.data) {
          this.series = response.data.results.stats;
          this.chartOptions.xaxis.categories = response.data.results.type_agencies;
          this.service_stats_headers = response.data.graph_stats.headers;
          this.service_stats_datas = response.data.graph_stats.data;
          this.chartOptions.plotOptions.bar.columnWidth = this.getPercentWidth(
            150,
            response.data.results.stats.length,
            14
          );
          this.$vs.loading.close();
          this.loading = false;
        }
      } catch (error) {
        this.$vs.loading.close();
        this.loading = false;
        console.log(error);
      }
    },
    getPercentWidth(chartWidth, series, columnWidth) {
      const percentWidth = Math.round(
        (columnWidth / (chartWidth / series)) * 100
      );
      console.log(percentWidth);
      return `${percentWidth}%`;
    },
    async exportPerfs() {
      try {
        this.$vs.loading();
        let params = {
          evaluation: this.evaluation_id ? this.evaluation_id : '',
          export: '1'
        }
        let response = await this.$http("/stats/rapport-tcc/touchpoint-result" + _buildQuery(params));

        if (response.data) {
          const url = response.data.file;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "export-touchpoint-overall-results.xlsx"
          );
          document.body.appendChild(link);
          link.click();

          this.$vs.loading.close();
        }
      } catch (error) {
        this.$vs.loading.close();
        if (error.response.status === 401) {
          this.$vs.notify({
            title: "Erreur",
            text: "Votre session a expiré",
            color: "danger",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-right",
          });
          this.$router.push({ name: "login" });
        }
      }
    }
  },
  mounted() {
    this.getEvaluations();
    this.getTouchPointStats();
  },
};
</script>

<style lang="scss" scoped>
.activate-button {
  background: white !important;
  border: 1px solid black;
  border-radius: 25px;
  font-size: 0.8em !important;
}

.export-button {
  background: #ffcc00 !important;
  border-radius: 25px;
  font-size: 0.8em !important;
}

.stats-block {
  font-size: 26px;
  color: #000000;
}

.left-card-container {
  display: flex;
  flex-direction: row;
}

.flex-item-left {
  flex: 40% !important;
}

.flex-item-right {
  flex: 60% !important;
  text-align: right;
}

/* Responsive layout - makes a one column-layout instead of two-column layout */
@media (max-width: 800px) {
  .left-card-container {
    flex-direction: column;
  }
}

.stats-perf {
  min-height: 200px;
}

.bg-table-stats {
  background: #F3F2F7;
}

table thead tr {
  background: #F3F2F7 !important;
}

.spinner {
  animation: rotate 2s linear infinite;
  z-index: 2;
  position: absolute;
  // top: 50%;
  left: 99.5%;
  margin: -25px 0 0 -25px;
  width: 27px;
  height: 50px;

  & .path {
    stroke: hsl(210, 70, 75);
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>